<template>
  <footer>
    <br />
    <div
      class="miDiv d-flex flex-wrap justify-content-center align-items-center"
      style="
        color: rgb(104, 103, 103);
        font-family: 'Big Shoulders Display', cursive;
      "
    >
      <div class="mb-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 movil">
        <img src="./icono.png" alt="" width="100px" />
        <h3 style="color: rgba(187, 187, 187, 0.44)">Tecnologies</h3>
        <p style="width: 80%; margin: auto; color: rgba(187, 187, 187, 0.44)">
          Lorem ipsum dus ut luctus felis sociis, vestibulum pretium cum
          nascetur dui quisque orci urna suscipit, non pulvinar et curabitur
          lobortis <br />
          erat tellus sociosqu. Leo rutrum bibenduda condimentum vehicula
          cubilia sollicitudin porttitor hendrerit ornare accumsan laoreet isi
          aptent vel risus phasellus natoque penatibu auctor.
        </p>
      </div>
      <div
        class="mb-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 movil"
        style="margin-top: 20px"
      >
        <div
          class="divF"
          style="border-bottom: 2px solid red; width: 24%; margin-top: -5px"
        >
          <h4 style="color: white">latest post</h4>
        </div>
        <div class="divF" style="margin-top: 10px">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-chevron-right"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
            /></svg
          >Lorem ipsum generator
          <p style="color: rgba(187, 187, 187, 0.24)">This is lorem</p>
        </div>
        <div class="divF">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-chevron-right"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
            /></svg
          >Lorem ipsum generator
          <p style="color: rgba(187, 187, 187, 0.24)">This is lorem</p>
        </div>
        <div class="divF">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-chevron-right"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
            /></svg
          >Lorem ipsum generator
          <p style="color: rgba(187, 187, 187, 0.24)">This is lorem</p>
        </div>
      </div>
      <div
        class="mb-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 movil"
        style="margin-top: 20px"
      >
        <div
          class="divF"
          style="border-bottom: 2px solid red; width: 24%; margin-top: -5px"
        >
          <h4 style="color: white">contact</h4>
        </div>
        <div class="divF" style="margin-top: 10px">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-chevron-right"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
            /></svg
          >Lorem ipsum generator
          <p style="color: rgba(187, 187, 187, 0.24)">This is lorem</p>
        </div>
        <div class="divF">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-chevron-right"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
            /></svg
          >Lorem ipsum generator
          <p style="color: rgba(187, 187, 187, 0.24)">This is lorem</p>
        </div>
        <div class="divF">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-chevron-right"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
            /></svg
          >Lorem ipsum generator
          <p style="color: rgba(187, 187, 187, 0.24)">This is lorem</p>
        </div>
      </div>
    </div>

    <br />
    <div
      class="rounded-social-buttons"
      style="padding: 20px; margin-top: -35px"
    >
      <a
        class="social-button facebook"
        href="https://www.facebook.com/"
        target="_blank"
        ><i class="fab fa-facebook-f"></i
      ></a>
      <a
        class="social-button twitter"
        href="https://www.twitter.com/"
        target="_blank"
        ><i class="fab fa-twitter"></i
      ></a>
      <a
        class="social-button linkedin"
        href="https://www.linkedin.com/"
        target="_blank"
        ><i class="fab fa-linkedin"></i
      ></a>
      <a
        class="social-button youtube"
        href="https://www.youtube.com/"
        target="_blank"
        ><i class="fab fa-youtube"></i
      ></a>
      <a
        class="social-button instagram"
        href="https://www.instagram.com/"
        target="_blank"
        ><i class="fab fa-instagram"></i
      ></a>
    </div>
    <br />
  </footer>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
  background: #d0d8db;
  padding-top: 60px;
  padding-bottom: 40px;
}

footer {
  background-color: #343a40;
}

textarea {
  resize: none;
}

.text {
  color: white;
  font-size: 20px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  white-space: nowrap;
}

.svg-inline--fa {
  vertical-align: -0.2em;
}

.rounded-social-buttons {
  text-align: center;
}

.rounded-social-buttons .social-button {
  display: inline-block;
  position: relative;
  cursor: pointer;
  width: 3.125rem;
  height: 3.125rem;
  border: 0.125rem solid transparent;
  padding: 0;
  text-decoration: none;
  text-align: center;
  color: #fefefe;
  font-size: 1.5625rem;
  font-weight: normal;
  line-height: 2em;
  border-radius: 1.6875rem;
  transition: all 0.5s ease;
  margin-right: 0.25rem;
  margin-bottom: 0.25rem;
}

.rounded-social-buttons .social-button:hover,
.rounded-social-buttons .social-button:focus {
  -webkit-transform: rotate(360deg);
  -ms-transform: rotate(360deg);
  transform: rotate(360deg);
}

.rounded-social-buttons .fa-twitter,
.fa-facebook-f,
.fa-linkedin,
.fa-youtube,
.fa-instagram {
  font-size: 25px;
}

.rounded-social-buttons .social-button.facebook {
  background: #3b5998;
}

.rounded-social-buttons .social-button.facebook:hover,
.rounded-social-buttons .social-button.facebook:focus {
  color: #3b5998;
  background: #fefefe;
  border-color: #3b5998;
}

.rounded-social-buttons .social-button.twitter {
  background: #55acee;
}

.rounded-social-buttons .social-button.twitter:hover,
.rounded-social-buttons .social-button.twitter:focus {
  color: #55acee;
  background: #fefefe;
  border-color: #55acee;
}

.rounded-social-buttons .social-button.linkedin {
  background: #007bb5;
}

.rounded-social-buttons .social-button.linkedin:hover,
.rounded-social-buttons .social-button.linkedin:focus {
  color: #007bb5;
  background: #fefefe;
  border-color: #007bb5;
}

.rounded-social-buttons .social-button.youtube {
  background: #bb0000;
}

.rounded-social-buttons .social-button.youtube:hover,
.rounded-social-buttons .social-button.youtube:focus {
  color: #bb0000;
  background: #fefefe;
  border-color: #bb0000;
}

.rounded-social-buttons .social-button.instagram {
  background: #125688;
}

.rounded-social-buttons .social-button.instagram:hover,
.rounded-social-buttons .social-button.instagram:focus {
  color: #125688;
  background: #fefefe;
  border-color: #125688;
}

.divF {
  color: white !important;
  border-bottom: 1px solid rgba(187, 187, 187, 0.24);
  width: 50%;
}

.movil {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto;
}
</style>
